import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { busDiemDonTraApi } from "../../../api/bus/busDiemDonTraApi";
import { busLoaiDiemDonApi } from "../../../api/bus/busLoaiDiemDonApi";
import { IBaseResponeModel } from "../../../models/response/base-response";
import {
	eBusDiemDonTraActionTypeIds,
	IBusDiemDonTraDeleteStart,
	IBusDiemDonTraImportStart,
	IBusDiemDonTraLoadStart,
	IBusDiemDonTraSaveStart,
	IBusDiemDonTraValidateImportStart
} from "../../action-types/bus/IBusDiemDonTraActionTypes";
import { busDiemDonTraActions } from "../../actions/bus/busDiemDonTraActions";

export function* busDiemDonTraSaga(): any {
	yield takeLatest(eBusDiemDonTraActionTypeIds.LOAD_START, loadBusDiemDonTraWorker)
	yield takeLatest(eBusDiemDonTraActionTypeIds.LOAD_LOAIDIEMDON_START, loadBusLoaiDiemDonWorker)
	yield takeEvery(eBusDiemDonTraActionTypeIds.SAVE_START, saveBusDiemDonTraWorker)
	yield takeEvery(eBusDiemDonTraActionTypeIds.DELETE_START, deleteBusDiemDonTraWorker)
	yield takeEvery(eBusDiemDonTraActionTypeIds.VALIDATE_IMPORT_START, validateImportBusDiemDonTraWorker)
	yield takeEvery(eBusDiemDonTraActionTypeIds.IMPORT_START, importBusDiemDonTraWorker)
}

function* loadBusDiemDonTraWorker(action: IBusDiemDonTraLoadStart): any {
	const res: IBaseResponeModel = yield call([busDiemDonTraApi, busDiemDonTraApi.SelectByCoSo], action.payload)
	if (res.is_success) {
		yield put(busDiemDonTraActions.loadBusDiemDonTraSuccess(res.data || []))
	} else {
		yield put(busDiemDonTraActions.loadBusDiemDonTraError(res.message || "Không tải được danh sách điểm đón trả"))
	}
}

function* loadBusLoaiDiemDonWorker(): any {
	const res: IBaseResponeModel = yield call([busLoaiDiemDonApi, busLoaiDiemDonApi.SelectAll])
	if (res.is_success) {
		yield put(busDiemDonTraActions.loadBusLoaiDiemDonSuccess(res.data || []))
	} else {
		yield put(busDiemDonTraActions.loadBusLoaiDiemDonError(res.message || "Không tải được danh sách loại điểm đón"))
	}
}

function* saveBusDiemDonTraWorker(action: IBusDiemDonTraSaveStart): any {
	let res: IBaseResponeModel;
	const is_update = action.payload.id > 0;
	if (is_update) {
		res = yield call([busDiemDonTraApi, busDiemDonTraApi.Update], action.payload);
	} else {
		res = yield call([busDiemDonTraApi, busDiemDonTraApi.Insert], action.payload);
	}
	if (res.is_success) {
		yield put(busDiemDonTraActions.saveBusDiemDonTraSuccess(is_update))
	} else {
		yield put(busDiemDonTraActions.saveBusDiemDonTraError(res.message || "Không lưu được điểm đón trả"))
	}
}

function* deleteBusDiemDonTraWorker(action: IBusDiemDonTraDeleteStart): any {
	const res: IBaseResponeModel = yield call([busDiemDonTraApi, busDiemDonTraApi.Delete], action.payload)
	if (res.is_success) {
		yield put(busDiemDonTraActions.deleteBusDiemDonTraSuccess())
	} else {
		yield put(busDiemDonTraActions.deleteBusDiemDonTraError(res.message || "Không xoá được điểm đón trả"))
	}
}

function* validateImportBusDiemDonTraWorker(action: IBusDiemDonTraValidateImportStart): any {
	const res: IBaseResponeModel = yield call([busDiemDonTraApi, busDiemDonTraApi.ValidateImport], action.payload)
	if (res.is_success) {
		yield put(busDiemDonTraActions.validateImportBusDiemDonTraSuccess(res.data || []))
	} else {
		yield put(busDiemDonTraActions.validateImportBusDiemDonTraError(res.message || "Có lỗi"))
	}
}

function* importBusDiemDonTraWorker(action: IBusDiemDonTraImportStart): any {
	const res: IBaseResponeModel = yield call([busDiemDonTraApi, busDiemDonTraApi.Import], action.payload)
	if (res.is_success) {
		yield put(busDiemDonTraActions.importBusDiemDonTraSuccess())
	} else {
		yield put(busDiemDonTraActions.importBusDiemDonTraError(res.message || "Có lỗi"))
	}
}
